import { PromoTargetSchema } from '@bonanza-social/promos';
import { createService, z } from '@bonanza-social/toolkit/api';

const ReffererQualificationActions = z.enum(['Bet']);

export const PromotionQualificationActions = z.object({
  type: ReffererQualificationActions,
  amount: z.number(),
});

const LandingPromo = z.object({
  title: z.string(),
  promoType: z.string(),
  subPromoType: z.string(),
  bannerImageUrl: z.string().url(),
  shortDescription: z.string(),
  longDescription: z.string(),
  termsAndConditions: z.string(),
  subTypeMeta: z
    .object({
      minimumQualificationAmount: z.number(),
    })
    .optional(),
  rewards: z.array(
    z.object({
      rewardTarget: PromoTargetSchema,
      rewardAmount: z.number(),
    }),
  ),
  slug: z.string().optional(),
  qualifyingActions: z.optional(z.array(PromotionQualificationActions)),
});

export const LandingPromosResponseSchema = z.object({
  promotions: z.array(LandingPromo),
});

export type LandingPromoType = z.infer<typeof LandingPromo>;

export default createService({
  getLandingPromos: {
    method: 'GET',
    url: '/Lobby/promotions/landing',
    responseSchema: LandingPromosResponseSchema,
  },
});
